import { Component } from '@angular/core';

@Component({
    selector: 'app-center-panel',
    templateUrl: './center-panel.component.html',
    styleUrl: './center-panel.component.less',
    standalone: false
})
export class CenterPanelComponent {

}
